import React from 'react';
import { Reveal } from './Reveal';
import { painPoints } from '../data/curriculum';
export function PainPointsSection() {
  return <section className="bg-brand-dark px-4 py-20 md:py-28" data-id="element-119" data-mp="2htbopmh5dzgg">
      <Reveal className="mx-auto max-w-5xl text-center" data-id="element-120" data-mp="2wpknyo11gcsv">
        <h2 className="text-3xl font-black text-brand-deep md:text-4xl" data-id="element-121" data-mp="2wmyegiul7n80">¿Te reconoces en estas situaciones?</h2>
        <p className="mt-4 text-brand-gray" data-id="element-122" data-mp="2rsb03ctas975">
          Si te pasa alguna de estas cosas, Biología Lista se hizo pensando en ti.
        </p>
        <div className="mt-12 grid gap-4 sm:grid-cols-2" data-id="element-123" data-mp="30rejkhwdmqm6">
          {painPoints.map(({
          icon: PointIcon,
          text
        }) => <article key={text} className="flex items-center gap-4 rounded-2xl border border-brand-deep/[0.06] bg-brand-alt p-5 text-left shadow-sm" data-id="element-124" data-mp="3fe7t16j7t26g">
              <PointIcon className="h-6 w-6 shrink-0 text-brand-green" aria-hidden="true" data-id="element-125" data-mp="3oh0j56gnv7up" />
              <span className="text-sm font-semibold leading-snug" data-id="element-126" data-mp="3kfna6ni9uojk">{text}</span>
            </article>)}
        </div>
        <p className="mt-12 font-serif text-2xl font-bold italic text-brand-green" data-id="element-127" data-mp="swkvdys8285o">Y mereces mucho más que eso.</p>
      </Reveal>
    </section>;
}